module.exports = __webpack_public_path__ + "img/isana-logo.16f0b7cb.jpg";